import { INewOrderSchema } from '../validation/NewOrderSchema';
import { IPartySchema } from '../validation/PartySchema';
import { transformPartyFromFormToService } from './transformPartyFromFormToService';
import { eTransactionCategory } from '../../../ui-toolkit/enums/eTransactionType';
import { ePartyPurpose } from '../../../ui-toolkit/enums/ePartyPurpose';
import { ICreateOrderRequest } from '../../../ui-toolkit/orders/interfaces/createOrder/ICreateOrderRequest';

const partiesAllowedByTransactionCategory = {
  [eTransactionCategory.Purchase]: [ePartyPurpose.buyer, ePartyPurpose.seller],
  [eTransactionCategory.Refinance]: [ePartyPurpose.borrower],
};
const filterPartiesByTransactionCategory = (transaction_category: eTransactionCategory) => (value: IPartySchema) =>
  partiesAllowedByTransactionCategory[transaction_category].includes(value.purpose);

export const transformFromFormToService = (values: INewOrderSchema): ICreateOrderRequest => {
  const result = { ...values };
  // The UI keeps the buyer/borrower distinction, while the api does not.
  const filteredParties = !!values.parties
    ? values.parties
        .filter(filterPartiesByTransactionCategory(values.transactionCategory))
        .map((t) => (t.purpose === ePartyPurpose.buyer ? { ...t, purpose: ePartyPurpose.borrower } : t))
    : [];

  result.parties = transformPartyFromFormToService(filteredParties);

  return result as ICreateOrderRequest;
};
